module.exports = __webpack_public_path__ + "media/images/icons/room-18a342cafc68e3a2e51b639d73db829a.svg";